import script from "./notification-bell.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-bell.vue?vue&type=script&setup=true&lang=js"

import "./notification-bell.vue?vue&type=style&index=0&id=1b0dbeca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b0dbeca"]])

export default __exports__